import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@algoacademy/design-system/web/actions/Accordion';
import { Divider } from '@algoacademy/design-system/web/layouts/Divider';
import { H4 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { P2 } from '@algoacademy/design-system/web/marketing/typography/Paragraph';
export type Question = {
  title: string;
  content: React.ReactNode;
};
type QAListProps = {
  questions: Question[];
};
export function QAList(t0) {
  const $ = _c(4);
  const {
    questions
  } = t0;
  let t1;
  if ($[0] !== questions) {
    t1 = questions.map(_temp);
    $[0] = questions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(q) {
  return <div key={q.title}><div className="px-4 py-3"><Accordion title={<H4 className="text-left">{q.title}</H4>}><P2 className="pt-1">{q.content}</P2></Accordion></div><Divider /></div>;
}